<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="类别集名称">
              <a-select show-search option-filter-prop="children" v-model="queryParams.categorySetName" allowClear>
                <a-select-option v-for="(item) in categorySetNameList" :key="item.key">{{ item.value }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="类别集说明">
              <a-input v-model="queryParams.categorySetDesc" allowClear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="状态">
              <a-select v-model="queryParams.status" show-search allowClear option-filter-prop="children">
                <a-select-option v-for="(item) in statusOptions" :key="item.dictValue">{{ item.dictLabel }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="onSearch" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <download-modal :apiFun="apiMdmItemCategorySetNewExport" ref="download" />
      <a-button @click="$refs.createModal.show()" type="primary" v-hasPermi="['mdm:itemCategorySet:add']">新增</a-button>
      <a-button @click="handleExport" v-hasPermi="['mdm:itemCategorySet:export']">导出</a-button>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1500 }"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.MATERIAL_CATEGORY_LIST, // 表格方案配置唯一值
              }"
        >
          <template slot="updateTime" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <template slot="createTime" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <template slot="multItemCatAssignFlag" slot-scope="{ record }">
            <a-popconfirm
              ok-text="确定"
              cancel-text="取消"
              @confirm="confirmHandleMICAF(record)"
              @cancel="cancelHandleMICAF(record)"
            >
              <span slot="title">请确认：<b>{{ record.multItemCatAssignFlag === 'Y' ? '该类别集将不允许存在多个物料类别分配' : '该类别集将允许存在多个物料类别分配' }}</b></span>
              <a-switch :checked="record.multItemCatAssignFlag === 'Y'" />
            </a-popconfirm>
          </template>
          <template slot="status" slot-scope="{ record }">
            <a-popconfirm
              ok-text="确定"
              cancel-text="取消"
              @confirm="confirmHandleStatus(record)"
              @cancel="cancelHandleStatus(record)"
            >
              <span slot="title">请确认是否<b>{{ record.status === 'Y' ? '停用' : '启用' }}</b></span>
              <a-switch :checked="record.status === 'Y'" />
            </a-popconfirm>
          </template>
          <!-- 操作 -->
          <span slot="operation" slot-scope="{ record }">
            <a @click="handleDetail('material-category-category', record)" v-hasPermi="['mdm:itemCategoryCode:detail']">查看类别代码</a>
            <a class="ml10" @click="handleDetail('material-category-distribution', record)" v-hasPermi="['mdm:itemApportion:detail']">查看物料类别分配</a>
          </span>
        </ls-api-table>

        <!-- 创建/编辑快码,单独封装了组件 -->
        <material-category-add
          ref="createModal"
          @handle-success="handleOk"
        />
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import { apiItemCategorySetEdit, apiItemCategorySetPullDownList, apiItemCategorySetList, apiMdmItemCategorySetNewExport } from '@/api/mdm/matter/material-category'
import MaterialCategoryAdd from './components/material-category-add'
import { generateLsTableResData } from '@/utils/util.js';
import DownloadModal from '@/views/components/download-modal/download-modal.vue'

export default {
  name: 'MaterialCategory',
  components: {
    DownloadModal,
    MaterialCategoryAdd
  },
  data () {
    return {
       apiMdmItemCategorySetNewExport,
       // 表格配置
       tableProps: {
        requestApi: generateLsTableResData(apiItemCategorySetList, true),
        pageCurrent: true
      },
      // 控制搜索展开
      advanced: true,
      // 查询参数
      queryParams: {
        organizationId: undefined,
        categorySetName: undefined,
        categorySetDesc: undefined,
        status: undefined
      },
      // 状态快码
      statusOptions: [
        {
          dictLabel: "有效",
          dictValue: "Y"
        },
        {
          dictLabel: "无效",
          dictValue: "N"
        }
      ],
      // 快码表格数据
      typeList: [],
      // 表格字段
      columns: [
        {
          title: '类别集名称',
          dataIndex: 'categorySetName',
          stickyFixed: 'left',
          ellipsis: true,
          align: 'center',
          width: 150
        },
        {
          title: '类别集说明',
          dataIndex: 'categorySetDesc',
          stickyFixed: 'left',
          ellipsis: true,
          align: 'center',
          width: 150
        },
        {
          title: '允许存在多个物料类别分配',
          dataIndex: 'multItemCatAssignFlag',
          width: 200,
          scopedSlots: { customRender: 'multItemCatAssignFlag' },
          align: 'center'
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          align: 'center'
        },
        {
          title: '最后修改人',
          dataIndex: 'updateBy',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '最后修改时间',
          dataIndex: 'updateTime',
          scopedSlots: { customRender: 'updateTime' },
          width: 150,
          align: 'center'
        },
        {
          title: '创建人',
          dataIndex: 'createBy',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          width: 150,
          align: 'center'
        },
        {
          title: '操作',
          width: 240,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          stickyFixed: 'right'
        }
      ],
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      rowSelection: {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
          this.selectedRows = selectedRows
        },
        onSelect: (record, selected, selectedRows) => {},
        onSelectAll: (selected, selectedRows, changeRows) => {}
      },
      categorySetNameList: [] // 类别集名称
    }
  },
  computed: {
    ...mapState({
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  created () {
    this.getPullDownList()
  },
  mounted () {
    this.onSearch()
  },
  methods: {
    // 页面跳转
    handleDetail (name, record) {
      this.$router.push({ name: name, query: { id: record.id } })
    },
    // 类别集名称-下拉框
    getPullDownList () {
      apiItemCategorySetPullDownList({ organizationId: this.organizationCodeOrigin }).then(res => {
        if (res.code === 200 && res.data && res.data.length > 0) {
          const arr = res.data;
          const list = [];
          arr.forEach(element => {
            const obj = {
              key: element.label,
              value: element.label
            }
            list.push(obj)
          });
          this.categorySetNameList = list
        }
      })
    },
    // 导入导出excel
    /** 导出按钮操作 */
    handleExport () {
      const params = this.queryParams
      this.$refs.download.openModal(params)
      // this.download('mdm/itemCategorySet/export', {
      //   ...this.queryParams
      // }, `物料类别_${new Date().getTime()}.xlsx`)
    },
    // 允许存在多个物料类别分配
    confirmHandleMICAF (row) {
      const text = row.multItemCatAssignFlag === 'Y' ? '停用' : '启用'
      row.multItemCatAssignFlag = row.multItemCatAssignFlag === 'Y' ? 'N' : 'Y'
      apiItemCategorySetEdit(row)
      .then(() => {
        this.$message.success(
          text + '成功',
          3
        )
        this.onSearch();
      }).catch(function () {
        row.multItemCatAssignFlag = row.multItemCatAssignFlag === 'Y' ? 'N' : 'Y'
        this.$message.error(
          text + '发生异常',
          3
        )
      })
    },
    cancelHandleMICAF (row) {
    },
    onSearch () {
      this.queryParams.organizationId = this.organizationCodeOrigin
      this.$refs.dataTable.searchParams = this.queryParams;
      this.$refs.dataTable.getData();
    },
    // 状态
    confirmHandleStatus (row) {
      const text = row.status === 'Y' ? '停用' : '启用'
      row.status = row.status === 'Y' ? 'N' : 'Y'
      apiItemCategorySetEdit(row)
      .then(() => {
        this.$message.success(
          text + '成功',
          3
        )
        this.onSearch()
      }).catch(function () {
        row.status = row.status === 'Y' ? 'N' : 'Y'
        this.$message.error(
          text + '发生异常',
          3
        )
      })
    },
    cancelHandleStatus (row) {
    },
    /** 查询快码类型列表 */
    getList (data) {
      this.typeList = data
    },
    // 新增/修改框事件
    handleOk () {
      this.onSearch()
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.onSearch()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
        organizationId: undefined,
        categorySetName: undefined,
        categorySetDesc: undefined,
        status: undefined
      }
      this.handleQuery()
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    }
  }
}
</script>

<style scoped lang="less">
.ml10{
  margin-left: 10px;
}
</style>
